import { motion } from 'framer-motion';
import styles from './LoadingScreen.module.css';

export default function LoadingScreen() {
    return (
        <div className={styles.container}>
            <motion.div
                className={styles.logo}
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                <div className={styles.seal}>
                    <span>GST</span>
                </div>
            </motion.div>
            <motion.p
                className={styles.text}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
            >
                Loading Autopilot...
            </motion.p>
            <motion.div
                className={styles.loader}
                initial={{ width: 0 }}
                animate={{ width: '100%' }}
                transition={{ duration: 1.5, ease: 'easeInOut' }}
            />
        </div>
    );
}
